module.exports = __webpack_public_path__ + "static/media/compact-disc.38a00b48.svg";